'use strict';
import * as $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024 from "./com.raquo.ew.-Js-Array$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_Lcom_raquo_airstream_ownership_Owner__$init$__V($thiz) {
  $thiz.Oc($j_com$002eraquo$002eew$002e$002dJs$002dArray$0024.$m_Lcom_raquo_ew_JsArray$().db($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($d_Lcom_raquo_airstream_ownership_Subscription.r().C)([]))));
}
export { $f_Lcom_raquo_airstream_ownership_Owner__$init$__V as $f_Lcom_raquo_airstream_ownership_Owner__$init$__V };
function $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V($thiz) {
  var arr = $thiz.ro();
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V(arr[i]);
    i = ((1 + i) | 0);
  }
  $thiz.ro().length = 0;
}
export { $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V as $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V };
function $f_Lcom_raquo_airstream_ownership_Owner__onKilledExternally__Lcom_raquo_airstream_ownership_Subscription__V($thiz, subscription) {
  var index = ($thiz.ro().indexOf(subscription) | 0);
  if ((index !== (-1))) {
    $thiz.ro().splice(index, 1);
  } else {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), "Can not remove Subscription from Owner: subscription not found.");
  }
}
export { $f_Lcom_raquo_airstream_ownership_Owner__onKilledExternally__Lcom_raquo_airstream_ownership_Subscription__V as $f_Lcom_raquo_airstream_ownership_Owner__onKilledExternally__Lcom_raquo_airstream_ownership_Subscription__V };
function $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V($thiz, subscription) {
  $thiz.ro().push(subscription);
}
export { $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V as $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V };
function $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V($thiz) {
  if ((!$thiz.yA)) {
    $thiz.Ey.h();
    $thiz.yA = true;
  } else {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), "Can not kill Subscription: it was already killed.");
  }
}
export { $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V as $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V };
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_Subscription(owner, cleanup) {
  this.Ez = null;
  this.Ey = null;
  this.yA = false;
  this.Ez = owner;
  this.Ey = cleanup;
  this.yA = false;
  owner.PP(this);
}
export { $c_Lcom_raquo_airstream_ownership_Subscription as $c_Lcom_raquo_airstream_ownership_Subscription };
$p = $c_Lcom_raquo_airstream_ownership_Subscription.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_Subscription;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_Subscription() {
}
export { $h_Lcom_raquo_airstream_ownership_Subscription as $h_Lcom_raquo_airstream_ownership_Subscription };
$h_Lcom_raquo_airstream_ownership_Subscription.prototype = $p;
$p.xB = (function() {
  $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V(this);
  $f_Lcom_raquo_airstream_ownership_Owner__onKilledExternally__Lcom_raquo_airstream_ownership_Subscription__V(this.Ez, this);
});
var $d_Lcom_raquo_airstream_ownership_Subscription = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_ownership_Subscription, "com.raquo.airstream.ownership.Subscription", ({
  h5: 1
}));
export { $d_Lcom_raquo_airstream_ownership_Subscription as $d_Lcom_raquo_airstream_ownership_Subscription };
